"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondarySnackbar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _core = require("./core");

var _propTypes = require("prop-types");

var _plateButton = require("../plate-button");

var _SvgIconClose = require("../svg/feathers/SvgIconClose");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["classes"];
(0, _loadStyles.default)(".c591de296{position:fixed;z-index:999;bottom:2.5rem;left:2.5rem;display:flex;box-sizing:border-box;-webkit-transform:translateY(calc(100% + 2.5rem));transform:translateY(calc(100% + 2.5rem));transition:-webkit-transform 225ms cubic-bezier(0,0,.2,1) 0s;transition:transform 225ms cubic-bezier(0,0,.2,1) 0s;transition:transform 225ms cubic-bezier(0,0,.2,1) 0s,-webkit-transform 225ms cubic-bezier(0,0,.2,1) 0s}.c90af2f94{background:var(--color-gray-90);box-shadow:0 .0625rem 0 var(--color-gray-20);border-radius:.375rem;max-width:37.5rem;box-sizing:border-box;padding:.375rem;display:flex;align-items:center}.c18fa0424{border-radius:.25rem;display:flex;align-items:center;justify-content:center;color:#fff;width:2rem;height:2rem;margin-right:.625rem;flex-grow:0;flex-shrink:0}.ca326dbaa{color:#fff;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;flex-grow:1;flex-shrink:1;margin-right:2.5rem;font-size:.875rem;font-weight:500;line-height:1.25rem}.c5f5d1d1a{padding-left:.625rem;display:flex;flex-grow:0;flex-shrink:0}.cf5a6ee9c{flex-grow:0;flex-shrink:0;padding-left:.625rem}.c1b68cfc0{-webkit-transform:none;transform:none}.c35a6ba6e .c18fa0424{background:var(--color-blue-90)}.cb58a35f9 .c18fa0424{background:var(--color-red-90)}");
var styles = {
  root: 'c591de296',
  content: 'c90af2f94',
  icon: 'c18fa0424',
  message: 'ca326dbaa',
  buttons: 'c5f5d1d1a',
  close: 'cf5a6ee9c',
  '--open': 'c1b68cfc0',
  '--view-usual': 'c35a6ba6e',
  '--view-warning': 'cb58a35f9'
};

var SecondarySnackbar = function SecondarySnackbar(props) {
  var classes = props.classes,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement(_core.CoreSnackbar, (0, _extends2.default)({}, rest, {
    cn: cn,
    nodeClose: /*#__PURE__*/_react.default.createElement(_plateButton.PlateButton, {
      hoverType: "dark",
      view: "dark"
    }, /*#__PURE__*/_react.default.createElement(_plateButton.PlateButtonIcon, null, /*#__PURE__*/_react.default.createElement(_SvgIconClose.SvgIconClose, null)))
  }));
};

exports.SecondarySnackbar = SecondarySnackbar;
var view = ['usual', 'warning'];
SecondarySnackbar.modes = {
  view: view
};
SecondarySnackbar.propTypes = {
  /* component logic props */
  messages: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    message: _propTypes.node.isRequired,
    view: (0, _propTypes.oneOf)(view)
  })).isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SecondarySnackbar.defaultProps = {
  classes: {}
};